<template>
  <div>
    <br />
    <v-container class="grey lighten-5">
      <v-row no-gutters>
        <!-- <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile> -->
        <!-- MODAL- -->
        <!-- <div>
                  <button class="add-btn" @click="$bvModal.show('register-modal')"
                    >ADD NEW CLIENT</button
                  > -->
        <!--LINK TO MODAL - CREATE UNIT PRODUCT - URL: units/unitId/productId-->
        <!-- <b-modal id="register-modal" hide-footer>
                    <template v-slot:modal-title>
                      Add a new client
                    </template>
                    <RegisterClient />
                  </b-modal>
                </div> -->
        <!--END OF MODAL-->
        <!-- </v-card>
            </v-col> -->
        <v-col cols="12" sm="8" md="12">
          <v-card class="pa-2" outlined tile>
            <div>
              <section v-if="errored">
                <p>
                  We are sorry, we are not able to retrieve this information at
                  the moment. Please try back later.
                </p>
              </section>
              <section v-else>
                <div v-if="loading">Loading...</div>
                <!-- Responsive & Accessible Data Table  -->
                <div v-else class="container">
                  <table class="responsive-table">
                    <thead>
                      <tr>
                        <th scope="col">Company name</th>
                        <!-- <th scope="col">Package</th> -->
                        <th scope="col">Experience bookings</th>
                        <th scope="col">Contact person</th>
                        <th scope="col">Email</th>
                        <th scope="col">Contact no.</th>
                        <th scope="col">Address</th>
                        <!-- <th scope="col">Country</th> -->
                        <th style="padding: 0 30px;" scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="clientInfo in clientInfo"
                        v-bind:key="clientInfo"
                        class="clientTable"
                      >
                        <th scope="row">
                          {{ clientInfo.name }}
                        </th>
                        <!-- <td data-title="Package">
                              {{ clientInfo.sub_package }}
                            </td> -->
                        <td>
                          <div
                            class="trashIcon"
                            @click="openBookingsTableStock"
                          >
                            <font-awesome-icon class="icon" icon="list" />
                          </div>
                          <!-- @click="deleteClient" -->
                        </td>
                        <td data-title="Contact person">
                          {{ clientInfo.contact_lname }}
                          {{ clientInfo.contact_fname }}
                        </td>
                        <td data-title="email">
                          {{ clientInfo.email_general }}
                        </td>
                        <td data-title="Contact no.">
                          {{ clientInfo.contact_no }}
                        </td>
                        <td data-title="Address">
                          {{ clientInfo.address }},
                          {{ clientInfo.postal_code }} {{ clientInfo.city }},
                          {{ clientInfo.country }}
                        </td>
                        <!-- <td data-title="Country">
                              {{ clientInfo.country }}
                            </td> -->
                        <td>
                          <div
                            class="trashIcon"
                            @click="
                              deleteClient(clientInfo.id, clientInfo.name)
                            "
                          >
                            <font-awesome-icon class="icon" icon="trash" />
                          </div>
                          <!-- @click="deleteClient" -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <ConfirmDialog
      :visible="showConfirmation"
      class="customClass"
    ></ConfirmDialog>

    <!-- CLIENT BOOKINGS TABLE-->
    <b-modal
      id="client-bookings-table"
      size="lg"
      body-class="hide-padding"
      hide-footer
      no-stacking
    >
      <template v-slot:modal-title>
        clientInfo.name
      </template>
      <div>
        <table class="responsive-table">
          <thead>
            <tr>
              <th scope="col">Booking date</th>
              <th scope="col">{{ $tc('unit', 1) }}</th>
              <th scope="col">Experience name</th>
              <th scope="col">Amount paid</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">DD/MM/YYYY</th>
              <td data-title="">Unit name</td>
              <td data-title="">Piran trail</td>
              <td data-title="">250EUR</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <!--end OF BOOKINGS TABEL -->
    <!-- <p v-else>
      Loading products
    </p> -->
  </div>
</template>

<script>
import axios from 'axios'
// import ProductService from '@/services/ProductService.js'
// import RegisterClient from '@/components/ui/RegisterClient.vue'

//import ProductCard from '@/components/ui/ProductCard.vue'
// import UnitCard from '@/components/ui/UnitCard.vue'
//import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'

//import { mapState } from 'vuex'
import ConfirmDialog from 'primevue/confirmdialog'

export default {
  components: {
    ConfirmDialog
    // RegisterClient
  },
  data() {
    return {
      clientInfo: null,
      loading: true,
      errored: false,
      showConfirmation: false,
      id: this.client.id //! sql: "DELETE from clients WHERE id = 'undefined'"
    }
  },
  mounted() {
    this.getClientList()
  },
  methods: {
    getClientList() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/clients`)
        .then(response => {
          this.clientInfo = response.data
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => (this.loading = false))
    },
    deleteClient(clientId, name) {
      this.$confirm.require({
        message: this.$t('accountDeleteConfirmation'),
        header: name,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.$store
            .dispatch('client/removeClient', clientId)
            .then(() => {
              alert(this.$t('clientDeletionSuccess'))
              this.getClientList()
            })
            .catch(e => console.log(e))
        },
        reject: () => {
          this.showConfirmation = false
        }
      })
    },
    openBookingsTableStock() {
      this.$bvModal.show('client-bookings-table')
    }
  },
  props: {
    client: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// Breakpoints
$bp-maggie: 15em;
$bp-lisa: 30em;
$bp-bart: 48em;
$bp-marge: 62em;
$bp-homer: 90em;

// Styles
// * {
//   @include box-sizing(border-box);

//   &:before{
//     @include box-sizing(border-box);
//   }
//   &:after {
//     @include box-sizing(border-box);
//   }
// }

// body {
//   font-family: $helvetica;
//   color: rgba(94,93,82,1);
// }

a {
  color: var(--primaryDark);

  &:hover,
  &:focus {
    color: var(--primaryDark);
  }
}

.container {
  // margin: 5% 3%;

  @media (min-width: $bp-bart) {
    // margin: 2%;
  }

  @media (min-width: $bp-homer) {
    // margin: 2em auto;
    // max-width: $bp-homer;
  }
}

.responsive-table {
  width: 100%;
  margin-bottom: 1.5em;
  border-spacing: 0;

  @media (min-width: $bp-bart) {
    font-size: 0.8em;
  }

  @media (min-width: $bp-marge) {
    font-size: 0.9em;
  }

  thead {
    // Accessibly hide <thead> on narrow viewports
    position: absolute;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    padding: 0;
    border: 0;
    height: 1px;
    width: 1px;
    overflow: hidden;

    @media (min-width: $bp-bart) {
      // Unhide <thead> on wide viewports
      position: relative;
      clip: auto;
      height: auto;
      width: auto;
      overflow: auto;
    }

    th {
      background-color: var(--bg-light);
      border: 1px solid var(--bg-light);
      font-weight: normal;
      text-align: center;
      color: var(--bright);

      &:first-of-type {
        text-align: left;
      }
    }
  }

  // Set these items to display: block for narrow viewports
  tbody,
  tr,
  th,
  td {
    display: block;
    padding: 0;
    text-align: left;
    white-space: normal;
  }

  tr {
    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-row;
    }
  }

  th,
  td {
    padding: 0.5em;
    vertical-align: middle;

    @media (min-width: $bp-lisa) {
      padding: 0.75em 0.5em;
    }

    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-cell;
      padding: 0.5em;
    }

    @media (min-width: $bp-marge) {
      padding: 0.75em 0.5em;
    }

    @media (min-width: $bp-homer) {
      padding: 0.75em;
    }
  }

  caption {
    margin-bottom: 1em;
    font-size: 1em;
    font-weight: bold;
    text-align: center;

    @media (min-width: $bp-bart) {
      font-size: 1.5em;
    }
  }

  tfoot {
    font-size: 0.8em;
    font-style: italic;

    @media (min-width: $bp-marge) {
      font-size: 0.9em;
    }
  }

  tbody {
    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-row-group;
    }

    tr {
      margin-bottom: 1em;

      @media (min-width: $bp-bart) {
        // Undo display: block
        display: table-row;
        border-width: 1px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      &:nth-of-type(even) {
        @media (min-width: $bp-bart) {
          background-color: rgba(94, 93, 82, 0.1);
        }
      }
    }

    th[scope='row'] {
      background-color: var(--bg-light);
      color: white;

      @media (min-width: $bp-lisa) {
        border-left: 1px solid var(--bg-light);
        border-bottom: 1px solid var(--bg-light);
      }

      @media (min-width: $bp-bart) {
        background-color: transparent;
        color: rgba(94, 93, 82, 1);
        text-align: left;
      }
    }

    td {
      text-align: right;

      @media (min-width: $bp-bart) {
        border-left: 1px solid var(--bg-light);
        border-bottom: 1px solid var(--bg-light);
        text-align: center;
      }

      &:last-of-type {
        @media (min-width: $bp-bart) {
          border-right: 1px solid var(--bg-light);
        }
      }
    }

    td[data-type='currency'] {
      text-align: right;
    }

    td[data-title]:before {
      content: attr(data-title);
      float: left;
      font-size: 0.8em;
      color: rgba(94, 93, 82, 0.75);

      @media (min-width: $bp-lisa) {
        font-size: 0.9em;
      }

      @media (min-width: $bp-bart) {
        // Don’t show data-title labels
        content: none;
      }
    }
  }
}
.add-btn {
  background: var(--primary);
  color: var(--bright);
  padding: 1em;
  letter-spacing: 3px;
  border-radius: 5px;
  width: 60%;
}

.trashIcon {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.3em;
  cursor: pointer;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 40px;
  height: 30px;
  margin-left: -20px;
  margin-top: -15px;
}

svg .trashIcon {
  margin-top: 3px;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}

@media screen and (max-width: 780px) {
  .add-btn {
    width: 80%;
  }
}
</style>
